import { Component, OnInit, Input } from '@angular/core';
import Config from '../../services/configuracion/config';

@Component({
  selector: 'imprimir-anuncio',
  templateUrl: './imprimir-anuncio.component.html',
  styleUrls: ['./imprimir-anuncio.component.scss']
})
export class ImprimirAnuncioComponent implements OnInit {
  @Input() anuncio: any;
  size: string = '';
  rutaImagen1: string;
  rutaImagen2: string;

  constructor() {
    this.anuncio = {};
  }

  ngOnInit() {}

  ngOnChanges() {
    console.log('******************** Anuncio ********************');
    console.log(this.anuncio);
    console.log('******************** Anuncio ********************');
    if (!!this.anuncio) {
      switch (this.anuncio.tarifa_id) {
        case "4":
          this.size = 'size-full';
          break;
        case "3":
          this.size = 'size-half';
          break;
        case "2":
          this.size = 'size-quarter';
          break;
        case "1":
          this.size = 'size-eighth';
          break;
      }

      const idImagenTmp1 = this.anuncio.imagenes.length > 0 ? this.anuncio.imagenes[0].id : null;
      const idImagenTmp2 = this.anuncio.imagenes.length > 1 ? this.anuncio.imagenes[1].id : null;

      this.rutaImagen1 = !!idImagenTmp1 ? [Config.ApiUrl, 'anuncio', idImagenTmp1, 'imagen'].join('/') : null;
      this.rutaImagen2 = !!idImagenTmp2 ? [Config.ApiUrl, 'anuncio', idImagenTmp2, 'imagen'].join('/') : null;
    } else {
      this.anuncio = {};
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/imprimir-anuncio/imprimir-anuncio.component.ts